import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import SugargooReviewPage from "@/pages/article-review/page";
import SugargooShippingPage from "@/pages/article-shipping/page";
import SugargooCouponPage from "@/pages/article-coupon/page";
import SugargooWarehousePage from "@/pages/article-warehouse/page";
import IsSugargooLegitPage from "@/pages/article-legit/page";
import SugargooBuyingGuidePage from "@/pages/article-buying-guide/page";
import SugargooBestFindsPage from "@/pages/article-best-finds/page";
import SugargooSpreadsheetLinksPage from "@/pages/article-links/page";
import SugargooAgentGuidePage from "@/pages/article-agent-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-ultimate-guide",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-review",
    element: <SugargooReviewPage />,
  },
  {
    path: "/sugargoo-shipping-cost",
    element: <SugargooShippingPage />,
  },
  {
    path: "/sugargoo-coupon",
    element: <SugargooCouponPage />,
  },
  {
    path: "/sugargoo-warehouse",
    element: <SugargooWarehousePage />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <IsSugargooLegitPage />,
  },
  {
    path: "/sugargoo-buying-guide",
    element: <SugargooBuyingGuidePage />,
  },
  {
    path: "/sugargoo-best-finds",
    element: <SugargooBestFindsPage />,
  },
  {
    path: "/sugargoo-spreadsheet-links",
    element: <SugargooSpreadsheetLinksPage />,
  },
  {
    path: "/sugargoo-agent-guide",
    element: <SugargooAgentGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;